window.GoogleTagManager = window.GoogleTagManager || []
window.GoogleTagManager.push({event: 'gtm.js', 'gtm.start': Date.now()})

// Deferring JavaScript bundle reduces bandwidth contention with critical resources
// like styles, LCP image/text and fonts.
import('/horizon/app-boot/app-boot').then(exports => exports.bootApp())
